import React from "react";
import { BrowserRouter, HashRouter, Switch } from "react-router-dom";
import { HomePage_Screen } from "../screens/homepage/homepage";
import { PerakendeSatisOzelWeb_Screen } from "../screens/perakendesatisozelweb/perakendesatisozelweb";
import { AlisFatura_Screen } from "../screens/alisfatura/alisfatura";
import { KasaDetay_Screen } from "../screens/kasadetay/kasadetay";
import { AlacakCekSenetList_Screen } from "../screens/alacakceksenetlist/alacakceksenetlist";
import { Support_Screen } from "../screens/support/support";
import { KategorSeciDetaySatinAlma_Screen } from "../screens/kategorsecidetaysatinalma/kategorsecidetaysatinalma";
import { Furkn_Screen } from "../screens/furkn/furkn";
import { PerakendeSatislarListesiOzel_Screen } from "../screens/perakendesatislarlistesiozel/perakendesatislarlistesiozel";
import { BankaList_Screen } from "../screens/bankalist/bankalist";
import { Yusf_Screen } from "../screens/yusf/yusf";
import { KoleksiyonSecSatis_Screen } from "../screens/koleksiyonsecsatis/koleksiyonsecsatis";
import { MasrafList_Screen } from "../screens/masraflist/masraflist";
import { KasaList_Screen } from "../screens/kasalist/kasalist";
import { UrunSecDetaySatinAlma_Screen } from "../screens/urunsecdetaysatinalma/urunsecdetaysatinalma";
import { ResetPassword_Screen } from "../screens/resetpassword/resetpassword";
import { UrunEnvanterAnaliz_Screen } from "../screens/urunenvanteranaliz/urunenvanteranaliz";
import { Signin_Screen } from "../screens/signin/signin";
import { SatinAlimDokumu_Screen } from "../screens/satinalimdokumu/satinalimdokumu";
import { MusteriDetay_Screen } from "../screens/musteridetay/musteridetay";
import { AlisFaturacopy_Screen } from "../screens/alisfaturacopy/alisfaturacopy";
import { SatisFatura_Screen } from "../screens/satisfatura/satisfatura";
import { EbatDetaySatis_Screen } from "../screens/ebatdetaysatis/ebatdetaysatis";
import { BorcCekSenetList_Screen } from "../screens/borcceksenetlist/borcceksenetlist";
import { MarkaBazindaSatinAlim_Screen } from "../screens/markabazindasatinalim/markabazindasatinalim";
import { ToplamSatinAlim_Screen } from "../screens/toplamsatinalim/toplamsatinalim";
import { BankaDetay_Screen } from "../screens/bankadetay/bankadetay";
import { ProfileScreen_Screen } from "../screens/profilescreen/profilescreen";
import { LeftMenu_Screen } from "../screens/leftmenu/leftmenu";
import { Signup_Screen } from "../screens/signup/signup";
import { VerificationCode_Screen } from "../screens/verificationcode/verificationcode";
import { PerakendeSatislarListesiOzelcopy_Screen } from "../screens/perakendesatislarlistesiozelcopy/perakendesatislarlistesiozelcopy";
import { Firat_Screen } from "../screens/firat/firat";
import { ForgotPassword_Screen } from "../screens/forgotpassword/forgotpassword";
import { UrunSatisAnaliz_Screen } from "../screens/urunsatisanaliz/urunsatisanaliz";
import { SairDekontList_Screen } from "../screens/sairdekontlist/sairdekontlist";
import { AccountDeletion_Screen } from "../screens/accountdeletion/accountdeletion";
import { MusteriList_Screen } from "../screens/musterilist/musterilist";
import { TedarikciDetay_Screen } from "../screens/tedarikcidetay/tedarikcidetay";
import { MagazaCiroAnalizi_Screen } from "../screens/magazaciroanalizi/magazaciroanalizi";
import { Privacy_Screen } from "../screens/privacy/privacy";
import { TedarikciList_Screen } from "../screens/tedarikcilist/tedarikcilist";
import { KrediKartiList_Screen } from "../screens/kredikartilist/kredikartilist";
import { MagazaCiroAnaliziOzel_Screen } from "../screens/magazaciroanaliziozel/magazaciroanaliziozel";
import { MarkaSecSatinAlma_Screen } from "../screens/markasecsatinalma/markasecsatinalma";
import { DesenDetaySatis_Screen } from "../screens/desendetaysatis/desendetaysatis";
import { Mrty_Screen } from "../screens/mrty/mrty";



import LocalStorageService from "../auth/local-storage-service";
import { Redirect } from "../auth/redirect";
import { IAppMode, IAuthType } from "../bootstrapper";
import { NoMatch404 } from "../components/common/no-match-404";
import { Dashboard, ForgotPassword, Login, ResetPassword } from "../components/default_screens/index";
import { KuikaInfo } from "../components/default_screens/kuika-info";
import { MfeLogin } from "../components/mfe/mfe-login";
import { MsalLogin } from "../components/msal/msal-login";
import { MsalRedirect } from "../components/msal/msal-redirect";
import { NotificationRedirect } from "../components/notification/notification-redirect";
import { ScanCompareTest } from "../screens/scan-compare-test";
import { WFMailInteraction } from "../screens/wf-mail-interaction";
import confJson from "../shared/json/conf.json";
import { KMainFunctions } from "../shared/utilty/main-functions";
import { MasterScreenWrapper } from "./master-screen-wrapper";
import { PrivateRoute } from "./private-route";
import { Route } from "./route";



export interface IRouterState {}

export type IRouterType = "HashRouter" | "BrowserRouter";

export interface IRouterProps {
  authType: IAuthType;
  routerType?: IRouterType;
  external_access_token?: string;
  external_refresh_token?: string;
  external_user?: string;
  external_provider_type?: string;
  startingScreen?: string;
  appMode?: IAppMode;
  // Allow only screenInput_* props with specific typing
  [key: `screenInput_${string}`]: unknown;
}

declare let window: any;
export class Router extends React.Component<IRouterProps, IRouterState> {
  timerId: any = null;

  private hasNavigatedToStartingScreen: boolean = false;

  componentDidMount = () => {
    // SET LANGUAGE TO HTML BODY
    const lang = LocalStorageService.getUserLanguage();
    if (lang) {
      const fixedLangAttributeValue = lang.replace("_", "-");
      document.body.setAttribute("lang", fixedLangAttributeValue);
    }
    // Handle starting screen navigation for web component apps (only once)
    if (this.props.appMode === "WebComponent" && this.props.startingScreen && !this.hasNavigatedToStartingScreen) {
      this.hasNavigatedToStartingScreen = true;
      this.navigateToStartingScreen();
    }

    window.onfocus = function () {
      if (window.kuika === undefined) {
        window.kuika = {};
      }
      window.kuika.isTabActive = true;
    };

    window.onblur = function () {
      if (window.kuika === undefined) {
        window.kuika = {};
      }
      window.kuika.isTabActive = false;
    };

    if (!window.styler_speed) {
      window.styler_speed = 20;
    } else if (window.styler_speed < 500) {
      window.styler_speed += 100;
    }

    if (window?.kuika?.activeKuikaComponent !== undefined) {
      return;
    }
    const runTimeout = () => {
      this.timerId = setTimeout(() => {
        const allFormItems: NodeListOf<HTMLElement> = document.querySelectorAll(".kFormItem");
        if (allFormItems) {
          allFormItems.forEach((formItem) => {
            if (formItem.getAttribute("data-display-affected") === "true") {
              return;
            }
            const antFormItemControlInputContent: HTMLElement = formItem.querySelector(
              ".ant-form-item-control .ant-form-item-control-input .ant-form-item-control-input-content"
            );
            const antFormItemControlInput: HTMLElement = formItem.querySelector(
              ".ant-form-item-control .ant-form-item-control-input"
            );
            const antFormItemControl: HTMLElement = formItem.querySelector(".ant-form-item-control");

            if (
              antFormItemControlInputContent &&
              antFormItemControlInputContent.children &&
              antFormItemControlInputContent.children.length > 0
            ) {
              const formChild: HTMLElement = antFormItemControlInputContent.children[0] as HTMLElement;
              let calculatedDisplay: string = formChild.style.display;
              if (
                calculatedDisplay &&
                antFormItemControl &&
                antFormItemControlInput &&
                antFormItemControlInputContent
              ) {
                if (calculatedDisplay === "inline-flex" || calculatedDisplay === "inline-block") {
                  calculatedDisplay = "";
                  formItem.style.width = formChild.style.width ?? "auto";
                  formItem.style.display = "inline-block";
                  formItem.setAttribute("data-display-affected", "true");
                }
              }
            }
          });
        }
        this.componentDidMount();
      }, window.styler_speed);
    };

    runTimeout();

    setTimeout(() => {
      clearTimeout(this.timerId);
    }, 10000);
  };

  private getScreenInputPropKeys = (): string[] => {
    return Object.keys(this.props || {}).filter((k) => k && k.startsWith("screenInput_"));
  };

  private buildScreenInputsFromProps = (): Record<string, unknown> => {
    const screenInputs: Record<string, unknown> = {};
    this.getScreenInputPropKeys().forEach((key) => {
      const inputName = key.substring("screenInput_".length);
      screenInputs[inputName] = this.props[key];
    });
    return screenInputs;
  };

  private navigateToStartingScreen = () => {
    try {
      const screenName = this.props.startingScreen as string;
      const baseHash = screenName.startsWith("#") ? screenName : `#${screenName}`;
      const inputs = this.buildScreenInputsFromProps();
      const params = new URLSearchParams();

      Object.keys(inputs).forEach((k) => {
        const v = inputs[k];
        if (v !== undefined && v !== null) {
          params.append(k, typeof v === "string" ? v : JSON.stringify(v));
        }
      });

      const qs = params.toString();
      const hash = `${baseHash}${qs ? `?${qs}` : ""}`;

      if (window.location.hash !== hash) {
        window.location.hash = hash;
      }
    } catch (e) {
      console.error("Error navigating to starting screen:", e);
    }
  };

  render() {
    const KuikaRouter = this.KuikaRouter();
    return (
      <>
        <KuikaRouter>
          <Switch key="Switch">
                        <PrivateRoute exact path="/" component={HomePage_Screen} />
                        <PrivateRoute exact path="/homepage" component={HomePage_Screen} />
            <PrivateRoute exact path="/perakendesatisozelweb" component={PerakendeSatisOzelWeb_Screen} />
            <PrivateRoute exact path="/alisfatura" component={AlisFatura_Screen} />
            <PrivateRoute exact path="/kasadetay" component={KasaDetay_Screen} />
            <PrivateRoute exact path="/alacakceksenetlist" component={AlacakCekSenetList_Screen} />
            <Route exact path="/support" component={Support_Screen} />
            <PrivateRoute exact path="/kategorsecidetaysatinalma" component={KategorSeciDetaySatinAlma_Screen} />
            <PrivateRoute exact path="/furkn" component={Furkn_Screen} />
            <PrivateRoute exact path="/perakendesatislarlistesiozel" component={PerakendeSatislarListesiOzel_Screen} />
            <PrivateRoute exact path="/bankalist" component={BankaList_Screen} />
            <PrivateRoute exact path="/yusf" component={Yusf_Screen} />
            <PrivateRoute exact path="/koleksiyonsecsatis" component={KoleksiyonSecSatis_Screen} />
            <PrivateRoute exact path="/masraflist" component={MasrafList_Screen} />
            <PrivateRoute exact path="/kasalist" component={KasaList_Screen} />
            <PrivateRoute exact path="/urunsecdetaysatinalma" component={UrunSecDetaySatinAlma_Screen} />
            <Route exact path="/resetpassword" component={ResetPassword_Screen} />
            <PrivateRoute exact path="/urunenvanteranaliz" component={UrunEnvanterAnaliz_Screen} />
            <Route exact path="/signin" component={this.LoginComponent()} />
            <Route exact path="/signin" component={Signin_Screen} />
            <PrivateRoute exact path="/satinalimdokumu" component={SatinAlimDokumu_Screen} />
            <PrivateRoute exact path="/musteridetay" component={MusteriDetay_Screen} />
            <PrivateRoute exact path="/alisfaturacopy" component={AlisFaturacopy_Screen} />
            <PrivateRoute exact path="/satisfatura" component={SatisFatura_Screen} />
            <PrivateRoute exact path="/ebatdetaysatis" component={EbatDetaySatis_Screen} />
            <PrivateRoute exact path="/borcceksenetlist" component={BorcCekSenetList_Screen} />
            <PrivateRoute exact path="/markabazindasatinalim" component={MarkaBazindaSatinAlim_Screen} />
            <PrivateRoute exact path="/toplamsatinalim" component={ToplamSatinAlim_Screen} />
            <PrivateRoute exact path="/bankadetay" component={BankaDetay_Screen} />
            <Route exact path="/profilescreen" component={ProfileScreen_Screen} />
            <PrivateRoute exact path="/leftmenu" component={LeftMenu_Screen} />
            <Route exact path="/signup" component={Signup_Screen} />
            <Route exact path="/verificationcode" component={VerificationCode_Screen} />
            <PrivateRoute exact path="/perakendesatislarlistesiozelcopy" component={PerakendeSatislarListesiOzelcopy_Screen} />
            <PrivateRoute exact path="/firat" component={Firat_Screen} />
            <Route exact path="/forgotpassword" component={ForgotPassword_Screen} />
            <PrivateRoute exact path="/urunsatisanaliz" component={UrunSatisAnaliz_Screen} />
            <PrivateRoute exact path="/sairdekontlist" component={SairDekontList_Screen} />
            <Route exact path="/accountdeletion" component={AccountDeletion_Screen} />
            <PrivateRoute exact path="/musterilist" component={MusteriList_Screen} />
            <PrivateRoute exact path="/tedarikcidetay" component={TedarikciDetay_Screen} />
            <PrivateRoute exact path="/magazaciroanalizi" component={MagazaCiroAnalizi_Screen} />
            <Route exact path="/privacy" component={Privacy_Screen} />
            <PrivateRoute exact path="/tedarikcilist" component={TedarikciList_Screen} />
            <PrivateRoute exact path="/kredikartilist" component={KrediKartiList_Screen} />
            <PrivateRoute exact path="/magazaciroanaliziozel" component={MagazaCiroAnaliziOzel_Screen} />
            <PrivateRoute exact path="/markasecsatinalma" component={MarkaSecSatinAlma_Screen} />
            <PrivateRoute exact path="/desendetaysatis" component={DesenDetaySatis_Screen} />
            <PrivateRoute exact path="/mrty" component={Mrty_Screen} />

            <Route path="/redirect" component={Redirect} />
            <Route path={"/login"} component={this.LoginComponent()} />
            
            
            <Route exact path="/forgotpassword" component={ForgotPassword} />
            <Route exact path="/resetpassword" component={ResetPassword} />
            <PrivateRoute exact path="/dashboard" component={Dashboard} />
            <Route exact path="/kuikainfo" component={KuikaInfo} />
            <Route exact path="/msalredirect" component={MsalRedirect} />
            <Route exact path="/wfmailinteraction" component={WFMailInteraction} />
            <PrivateRoute exact path="/scancomparetest" component={ScanCompareTest} />
            <Route exact path="/notificationredirect" component={NotificationRedirect} />
            <Route exact path="/logout" component={Redirect} />
            <Route path="*" component={NoMatch404} />
          </Switch>
        </KuikaRouter>
      </>
    );
  }

  KuikaRouter = () => {
    // Web component case
    let isWebComponentApp: any;
    isWebComponentApp = this.props.appMode === "WebComponent";
    if (
      confJson?.domainName !== undefined &&
      confJson?.applicationName !== undefined &&
      confJson?.applicationName !== "" &&
      window.kuika !== undefined &&
      window.kuika?.apps !== undefined &&
      window.kuika?.apps.length !== undefined &&
      window.kuika?.apps.length > 0
    ) {
      window.kuika?.apps.forEach((app: any) => {
        if (app.appName === confJson.applicationName && app.workspace === confJson.domainName) {
          isWebComponentApp = true;
        }
      });
    }
    if (window.kuika === undefined) {
      window.kuika = {};
    }
    window.kuika.isWebComponentApp = isWebComponentApp;

    // Embedded MFE containers need to know whose routing space window.location.hash
    // is: theirs (pathname-routed shell) or the shell's own. A hash-routed shell
    // means a hash is never a microapp deep link — see mfe-initial-navigation.ts.
    //
    // First writer wins: an embedded microapp bundle runs its own copy of this
    // Router (always a HashRouter) on the SAME window, and it must not overwrite the
    // shell's answer. The shell's route tree renders before it can load any bundle,
    // so the first write is always the outermost app's.
    const isHashRouted: boolean = isWebComponentApp === true || this.props.routerType === "HashRouter";
    if (window.kuika.isShellHashRouted === undefined) {
      window.kuika.isShellHashRouted = isHashRouted;
    }

    if (isHashRouted) {
      return (props: any) => {
        return <HashRouter key="HashRouter">{props.children}</HashRouter>;
      };
    }
    return (props: any) => {
      if (KMainFunctions.virtualDirectoryURL === "auto" || window?.location?.protocol === "file:") {
        return <BrowserRouter key="BrowserRouter">{props.children}</BrowserRouter>;
      }
      return (
        <BrowserRouter basename={KMainFunctions.virtualDirectoryURL} key="BrowserRouter">
          {props.children}
        </BrowserRouter>
      );
    };
  };

  LoginComponent = () => {
    if (this.props.authType === "MSAL") {
      return MsalLogin;
    }

    const { external_access_token } = this.props;
    const { external_refresh_token } = this.props;
    const { external_user } = this.props;
    const { external_provider_type } = this.props;
    // A Kuika host injects external_access_token as a short-lived MFE handoff
    // JWT; no refresh_token is involved — the microapp's own backend mints its
    // session cookies once the token is redeemed. A non-Kuika host injects its
    // own token plus external_provider_type, naming the customer's
    // External1..External5 validator that will verify it.
    if (external_access_token !== null && external_access_token !== undefined && external_access_token !== "") {
      return (props: any) => {
        return (
          <MfeLogin
            external_user={external_user}
            external_access_token={external_access_token}
            external_refresh_token={external_refresh_token}
            external_provider_type={external_provider_type}
          ></MfeLogin>
        );
      };
    }

    if (this.props.authType === "Kuika") {
      return Signin_Screen;
    }
    return <></>;
  };
}
